// ./src/config/colorPalette.ts
//
// A curated, theme-friendly color palette reused everywhere the app lets a user
// pick a color from presets — tags, audience groups, event-website elements,
// etc. The colors are visually distinct and give good contrast for text
// overlays. Kept dependency-free so any layer can import it.

export const DEFAULT_COLOR_PALETTE = [
  "#3B82F6", // Blue
  "#8B5CF6", // Purple
  "#EC4899", // Pink
  "#EF4444", // Red
  "#F97316", // Orange
  "#F59E0B", // Amber
  "#84CC16", // Lime
  "#10B981", // Emerald
  "#14B8A6", // Teal
  "#06B6D4", // Cyan
  "#6366F1", // Indigo
  "#A855F7", // Violet
] as const;
